import React from 'react'
import PropTypes from 'prop-types'

import { Box, Dialog } from '@material-ui/core'
import { Close } from '@material-ui/icons'

import routes from 'artkive/utils/routes'

/**
 * NOTE: doesn't support SSR
 */
const Preview = ({ onClose, fullScreen, ...props }) => {
  return (
    <Dialog fullScreen={fullScreen} {...props} aria-labelledby='form-dialog-title'>
      <Box position='relative'>
        <Close
          color='primary'
          fontSize='large'
          onClick={onClose}
          style={{ cursor: 'pointer', position: 'absolute', top: '1rem', right: '1rem' }}
        />
        <iframe
          border='0'
          width='100%'
          height='100vh'
          src={routes.accountBookPreview}
          style={{ minHeight: fullScreen ? '100vh' : '90vh' }}
          allowFullScreen
        ></iframe>
      </Box>
    </Dialog>
  )
}

Preview.propTypes = {
  onClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
}

export default Preview
